import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormAddSubSubCategory = () => {
  document.title = "Add Sub Sub Category | Uma Classes";

  const [formData, setFormData] = useState({
    name: "",
    category: "", // New field for the selected category
    subcategory: "",
  });

  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [categories, setCategories] = useState([]); // State to store fetched categories
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state for categories

  // Fetch categories from API on component mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://uma.aasmo.in/api/admin/getall-category',{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        });
        setCategories(response); // Assuming the API returns an array of categories
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoading(false); // Ensure loading is set to false even on error
      }
    };
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get('https://uma.aasmo.in/api/admin/getall-subcategory',{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        });
        setSubCategories(response); // Assuming the API returns an array of categories
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoading(false); // Ensure loading is set to false even on error
      }
    };
    fetchCategories();
    fetchSubCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://uma.aasmo.in/api/admin/add-subsubcategory', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });
      setSuccessMessage("Sub  Sub Category added successfully"); // Update success message
      setErrorMessage(""); // Clear any previous error messages
      setFormData({ name: "", category: "",subcategory: "" }); // Reset form
    } catch (error) {
      console.error("Error adding Sub Sub Category:", error);
      setSuccessMessage(""); // Clear any previous success messages
      setErrorMessage(error.response?.data?.message || "Error adding Sub Sub Category"); // Display specific error message from the response
    }
  };

  if (loading) {
    return <div>Loading sub sub categories...</div>; // Optional loading message
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Courses" breadcrumbItem="Add Sub Sub Category" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-2 col-form-label">
                        Sub Sub Category Name
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="category" className="col-md-2 col-form-label">
                        Select Category
                      </label>
                      <div className="col-md-10">
                        <select
                          className="form-control"
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                          required // Make the select required
                        >
                          <option value="">Select a category</option>
                          {categories.map((category) => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="subcategory" className="col-md-2 col-form-label">
                        Select Sub Category
                      </label>
                      <div className="col-md-10">
                        <select
                          className="form-control"
                          id="subcategory"
                          name="subcategory"
                          value={formData.subcategory}
                          onChange={handleChange}
                          required // Make the select required
                        >
                          <option value="">Select a sub category</option>
                          {subCategories.map((subcategory) => (
                            <option key={subcategory._id} value={subcategory._id}>
                              {subcategory.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <button type="submit" className="btn btn-primary">Add</button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormAddSubSubCategory;
